import { render, staticRenderFns } from "./usermamage.vue?vue&type=template&id=4d991e1d&"
import script from "./usermamage.vue?vue&type=script&lang=js&"
export * from "./usermamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports